import { put } from 'redux-saga/effects';
import { push } from 'redux-little-router';

export function* confirmODSaga({ payload: { step } }) {
  yield put(push({ query: { step } }, { persistQuery: true }));
}
